import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { User } from '../model/user/user';
import { AuthService } from './auth-service.service';
import { UserService } from '../services/user/user.service';
import { Role } from '../enums/role.enum';

@Injectable({
  providedIn: 'root'
})
export class CitizenGuardService  implements CanActivate {

  public userDetails: firebase.User = null;
  public user: User;
  constructor(private auth: AuthService, private router: Router, private userService: UserService) { }

   canActivate() {
    
    if (this.auth.isLoggedIn()) {
      this.userDetails = JSON.parse(localStorage.getItem('userAuth'));
      this.userService.userHasRole(this.userDetails.uid, Role.CIUDADANO.toString()).then((exists) => {
        if (exists) {
          return true;
        } else {
          this.router.navigate(['/']);
        }
      }).catch((err) => {
        this.router.navigate(['/']);
      });
    }
    this.router.navigate(['/']);
    return false;
  }
}
